import { gql } from '@apollo/client/core';
import store from '../store/index';
import { makeRequest } from '@/graphs/index';
import { findOrganizationsV2 } from '@/graphs/organization';
import { isStickerHost } from '@/utils/stickerHost';

const findStickerOwner = gql`query FindStickerOwner($id: String!) {
  findSticker(id: $id) {
    id
    entity
    entityId
    organization { id }
    user { id }
  }
}`;

async function loadManagedOrganizationIds(): Promise<string[]> {
  const known: string[] = store.getters['organizations/GET_USER_MANAGED_ORGANIZATION_IDS'] ?? [];
  if (known.length) return known;

  const response = await makeRequest('query', findOrganizationsV2, {
    baseInput: {
      ids: null,
      entity: null,
      entityIds: null,
      isActive: null,
      statuses: 'Approved',
      excludeUnclaimed: true,
      query: null,
      page: 1,
      pageSize: 50,
    },
  }, undefined);
  const organizations = response?.data?.findOrganizationsV2 ?? [];
  store.commit('organizations/MUTATE_USER_MANAGED_ORGANIZATIONS', organizations);
  return store.getters['organizations/GET_USER_MANAGED_ORGANIZATION_IDS'] ?? [];
}

/**
 * Host-only event pages (check-in, announcements, questions, insights): anyone else goes back to
 * the sticker page, like the sticker analytics page does. The backend refuses the data anyway.
 */
export default async function hostOnlyGuard(to: any): Promise<true | string> {
  const meId = store.getters['users/me']?.id;
  // Signed out: the auth guard sends the visitor to sign-in
  if (!meId) return true;

  const stickerId = String(to.params.stickerId);
  try {
    const [stickerResponse, myOrgIds] = await Promise.all([
      makeRequest('query', findStickerOwner, { id: stickerId }, undefined),
      loadManagedOrganizationIds(),
    ]);
    const sticker = stickerResponse?.data?.findSticker;
    if (sticker && isStickerHost(sticker, meId, myOrgIds)) return true;
  } catch (error) {
    console.error('Host check failed:', error);
  }
  return `/web/sticker/${stickerId}`;
}
